<template>
    <div class="search" :style="cataChange ? { marginTop: '24px' } : {}">
        <div class="searchBar">
            <div class="homeSearchBar">
                <div
                    class="cataChoose cursorPoint"
                    @click="cataSwitch()"
                    v-if="$route.name == 'home'"
                >
                    <img
                        :src="Images.Home.Search.cancel"
                        alt=""
                        v-if="cataChange"
                        class="closeImg"
                    />
                    <img
                        :src="CataNowList[Category].iconPath"
                        alt=""
                        v-if="!cataChange"
                    />
                    <h4>
                        {{
                            cataChange
                                ? $t("home.search.close")
                                : Category != "AllProduct"
                                ? CataNowList[Category][locales]
                                : $t("home.search.all")
                        }}
                    </h4>
                </div>

                <div class="slideBg" :class="MobileFix ? 'ShiftBg' : ''"></div>
                <div
                    v-if="$route.name == 'products' && Mobile"
                    class="cataMobile"
                    @click="mobileChangeCata"
                    :class="MobileFix ? 'Shift' : ''"
                >
                    <img :src="CataNowList[categoryNow].iconPath" alt="" />
                </div>
                <div class="homeInputBox productInputBox" :style="{'opacity':YentekWire?0.2:1}">
                    <img
                        :src="Images.Home.Search.search"
                        alt=""
                        :class="
                            keywords.length != 0
                                ? 'zero'
                                : indentStatus
                                ? 'zero'
                                : ''
                        "
                    />
                    <input
                        type="text"
                        :placeholder="$t('home.search.placeholder')"
                        @focus="indentStatus = true"
                        @blur="indentStatus = false"
                        :class="keywords.length != 0 ? 'indentMove' : ''"
                        v-model="keywords"
                        :disabled="YentekWire"
                    />
                    <transition
                        enter-active-class="animated fadeIn"
                        leave-active-class="animated fadeOut"
                    >
                        <img
                            :src="Images.Home.Search.cancel"
                            alt=""
                            v-if="keywords.length != 0"
                            @click="clearText"
                        />
                    </transition>
                </div>
                <div
                    class="homeInputBox productInputBox fixBar"
                    :class="MobileFix ? 'Shift' : ''"
                    v-if="Mobile && $route.name == 'products'"
                    :style="{'opacity':YentekWire?0.2:1}"
                >
                    <img
                        :src="Images.Home.Search.search"
                        alt=""
                        :class="
                            keywords.length != 0
                                ? 'zero'
                                : indentStatus
                                ? 'zero'
                                : ''
                        "
                    />
                    <input
                        type="text"
                        :placeholder="$t('home.search.placeholder')"
                        @focus="indentStatus = true"
                        @blur="indentStatus = false"
                        :class="keywords.length != 0 ? 'indentMove' : ''"
                        v-model="keywords"
                        :disabled="YentekWire"
                        
                    />
                    <transition
                        enter-active-class="animated fadeIn"
                        leave-active-class="animated fadeOut"
                    >
                        <img
                            :src="Images.Home.Search.cancel"
                            alt=""
                            v-if="keywords.length != 0"
                            @click="clearText"
                        />
                    </transition>
                </div>
            </div>
            <div class="homeCataList" v-if="cataChange">
                <div
                    @click="cataSwitch(key)"
                    v-for="(cata, key) in CataNowList"
                    :class="key == Category ? 'actived' : ''"
                    v-if="CataNowList"
                >
                    <img :src="cata.iconPath" alt="" />
                    <h5>{{ cata[locales] }}</h5>
                </div>
            </div>
        </div>
        <div class="resultWrapper" :class="listClass">
            <slot name="homeList">
                <div class="emptyHome"></div>
            </slot>
            <slot name="YentekWire"></slot>
            <slot name="productList">
                <h3 v-if="$route.name == 'products'">
                    {{ $t("Products.empty") }}
                </h3>
            </slot>
            
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters } from "vuex";
export default {
    name: "Search",
    props: {
        MobileFix: Boolean,
        YentekWire:Boolean,
    },
    data() {
        return {
            keywords: "",
            dTimer: null,
            Category: "McCwG9uaNqQIIY5HqlgL",
            indentStatus: false,
            cataChange: false,
        };
    },
    computed: {
        ...mapState("frontend", [
            "products",
            "categories",
            "Images",
            "categoryNow",
            "locales",
        ]),
        ...mapGetters("frontend", ["CataNowList", "Mobile"]),
        listClass() {
            return this.$route.name == "home" ? "homeResult" : "productResult";
        },
    },
    mounted() {},
    methods: {
        searchText() {
            if (this.keywords.length > 0)
                this.$emit("searching", this.keywords);
            else this.$emit("searching", "");
        },
        clearText() {
            this.keywords = "";
        },
        debounce(fn, wait) {
            if (this.dTimer !== null) {
                clearTimeout(this.dTimer);
            }
            this.dTimer = setTimeout(fn, wait);
        },
        cataSwitch(Value) {
            this.cataChange = !this.cataChange;
            this.Category = Value ? Value : this.Category;
        },
        mobileChangeCata() {
            this.$router.replace({ query: { Popup: "category" } });
        },
    },
    watch: {
        keywords(str) {
            if (str.trim().length !== 0) {
                this.debounce(this.searchText, 400);
            } else {
                this.debounce(this.searchText, 600);
            }
        },
        Category(cata) {
            this.$emit("searchSwitch", cata);
        },
    },
};
</script>